import { EmailCTA } from "../../../../src/components/ctas/email";
import * as React from 'react';
export default {
  EmailCTA,
  React
};